import StorageManager from '../utils/StorageManager';

export const decodeToken = () => {
    try {
        // Sprawdź token w obu miejscach
        const token = StorageManager.safeGetItem('token', 'session') || 
                     sessionStorage.getItem('token');

        if (!token) return null;
        
        // Dekoduj token JWT (część payload)
        return JSON.parse(atob(token.split('.')[1]));
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};

export const getUserRole = () => {
    // Najpierw próbujemy z tokenu
    const decodedToken = decodeToken();
    if (decodedToken?.role) return decodedToken.role;

    // Jeśli nie ma w tokenie, sprawdź bezpośrednio zapisaną rolę
    return StorageManager.safeGetItem('role', 'session') || 
           sessionStorage.getItem('role') || 
           null;
};